import React, { Suspense, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { sideBarMenu } from '../../Assets/Constants/json_constants';
import { useSelector } from 'react-redux';
import { FetchMenuDetails } from '../../Services/APIConfig';
import CustomToast from '../Common/CustomToast';

const UnProtectedLayout = () => {
  const { showToast } = CustomToast();
  const navigate = useNavigate();
  let { menu } = useSelector(state => state.auth.userInfo);
  useEffect(() => {
    if (localStorage.getItem('authToken')) {
      if (!menu) {
        fetchMenuDetails();
        return;
      }
      menuNavigate(menu);
    }
  }, [menu]);
  const fetchMenuDetails = async () => {
    const response = await FetchMenuDetails();
    if (response?.status === 200) {
      menu = response?.result?.[0].permissions;
      if (Object.keys(menu).length === 0) {
        showToast('error', 'There is no permission for this user');
      }
      menuNavigate(menu);
    }
  };
  const menuNavigate = menu => {
    let menuItem = Object.keys(menu);
    let temp = sideBarMenu
      .filter(val => val.title != 'Logo')
      .filter(data => {
        if (data.title === 'UAM') {
          if (menuItem.includes('Approval') && Object.keys(menu['Approval']).includes('uam_approval_request')) {
            return data;
          }
        }
        if (data.title === 'Dashboard') {
          if (menuItem.includes('Approval') && Object.keys(menu['Approval']).includes('dashboard_approval_request')) {
            return data;
          }
        }
        if (menuItem.includes(data.title) || data.title == 'Logo') {
          return data;
        }
      });
    temp.length > 0 && navigate(temp[0].link);
  };
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Outlet />
    </Suspense>
  );
};

export default UnProtectedLayout;
